import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { isWelcomeRoute } from "../../onboarding/first-install-redirect";
import { isWmsRoute } from "../wms-route";

/** How long after signup a new OMS user is steered to a computer. */
export const DESKTOP_HANDOFF_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

/** New OMS users on a phone, past the welcome flow; warehouse pages are exempt. */
export function shouldShowDesktopHandoff(args: {
  isSmallScreen: boolean;
  continuedOnMobile: boolean;
  omsEnabled: boolean;
  isAdminImpersonation?: boolean;
  user: { createdAt: string; email: string } | null | undefined;
  pathname: string;
  now: number;
}): boolean {
  const { user } = args;
  if (
    !args.isSmallScreen ||
    args.continuedOnMobile ||
    !args.omsEnabled ||
    args.isAdminImpersonation ||
    !user ||
    isRedoEmailAddress(user.email) ||
    isWmsRoute(args.pathname) ||
    isWelcomeRoute(args.pathname)
  ) {
    return false;
  }
  const createdAt = Date.parse(user.createdAt);
  return (
    !Number.isNaN(createdAt) && args.now - createdAt < DESKTOP_HANDOFF_WINDOW_MS
  );
}
